import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {ALL_ROUTES} from "./app-custom-routes";

@NgModule({
  imports: [RouterModule.forRoot(ALL_ROUTES, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
